module.exports = __webpack_public_path__ + "img/EMT-CRC_GSE225857.0e3e72ee.png";